import * as ApiBase from '@/api/apiBase';
import Unavailability from '@/models/unavailability/unavailability';

export async function getMyUnavailability(): Promise<Unavailability[]> {
  const http = await ApiBase.createHttpRequest();
  const result = await http.get('/unavailability');
  return result.data;
}

export async function updateMyUnavailability(unavailability: Unavailability, endDate: string): Promise<Unavailability> {
  const http = await ApiBase.createHttpRequest();
  const result = await http.post('/unavailability', {
    data: { 
      unavailability,
      copyTo: endDate
    }
  });
  return result.data;
}

export async function deleteMyUnavailability(unavailability: Unavailability): Promise<void> {
  const http = await ApiBase.createHttpRequest();
  await http.delete('/unavailability', {
    data: {
      unavailability
    }
  });
}